var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderOutlined = props => {
  props = {
    ...props,
    style: {
      display: 'inline-block',
      width: '1em',
      height: '1em',
      maxWidth: '100%',
      maxHeight: '100%',
      fill: 'currentColor',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      ...props.style
    }
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 29c.563 0 1.036-.193 1.422-.578.385-.386.578-.86.578-1.422V9c0-.563-.193-1.036-.578-1.422A1.933 1.933 0 0 0 30 7H15l-3-3H2c-.563 0-1.036.193-1.422.578C.193 4.964 0 5.438 0 6v21c0 .563.193 1.036.578 1.422.386.385.86.578 1.422.578h28Zm0-2H2V6h9.094l2.437 2.406.625.594H30v18Z"
  })));
};
export default SvgFolderOutlined;